import { useEffect, useState } from "react"
import type { SelectOptionType, SuccessFetch } from "types"
import { useApi } from "utils"


export const useDropdownDocumentType = () => {
    const api = useApi()
    const [data, setData] = useState<SelectOptionType[]>([])
    const [isLoading, setLoading] = useState(true)

    useEffect(() => {
        api.get("/documenttype/")
            .then((res: SuccessFetch<{
                payload: {
                    mr_document_id: number,
                    mr_document_name: string,
                }[]
            }>) => {

                setData(res.data.payload.map(item => {
                    return {
                        label: item.mr_document_name,
                        value: item.mr_document_id.toString(),
                    }
                }))
            })
            .catch(() => setData([]))
            .finally(() => setLoading(false))

        return () => {
            setData([])
            setLoading(true)
        }

        // eslint-disable-next-line
    }, [])

    return { data, isLoading }
}